import { RolloutWatchSummary } from '../../api/rollout';
import {
    buildSummary,
    moment,
    parseBuilds,
    span,
    WATCH_STATUS,
} from './rolloutModel';
import { Card } from './rolloutParts';

/** Every watch of one environment, newest first; one click opens it on Bewaken. */
export const WatchHistory = ({
    watches,
    now,
    onOpen,
}: {
    watches?: RolloutWatchSummary[];
    now: number;
    onOpen: (id: string) => void;
}) => (
    <Card title="Eerdere wachten">
        {!watches ? (
            <div className="ro-empty">Laden…</div>
        ) : watches.length === 0 ? (
            <div className="ro-empty">
                <strong>Nog geen wachten</strong>
                Na de eerste deploy staat hier elke wacht met zijn verslag.
            </div>
        ) : (
            <div className="ro-scroll">
                <table className="ro-table ro-table--rows">
                    <thead>
                        <tr>
                            <th>Deploy</th>
                            <th>Status</th>
                            <th>Build</th>
                            <th>Gestart door</th>
                        </tr>
                    </thead>
                    <tbody>
                        {watches.map((w) => (
                            <tr
                                key={w.rowKey}
                                onClick={() => onOpen(w.rowKey)}
                                tabIndex={0}
                                onKeyDown={(e) =>
                                    e.key === 'Enter' && onOpen(w.rowKey)
                                }
                            >
                                <td>
                                    {w.kind === 'monitor' && (
                                        <span className="ro-pill">Monitor</span>
                                    )}{' '}
                                    {moment(w.deployedAt)}{' '}
                                    <span className="ro-muted">
                                        ({span(now - Date.parse(w.deployedAt))}{' '}
                                        geleden)
                                    </span>
                                </td>
                                <td>
                                    <span
                                        className={`ro-pill ro-pill--${w.status}`}
                                    >
                                        {WATCH_STATUS[w.status]}
                                    </span>
                                </td>
                                <td>
                                    {buildSummary(parseBuilds(w.buildAfter)) ||
                                        '–'}
                                </td>
                                <td>{w.startedBy ?? '–'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </Card>
);
